import { useSetState } from '@/shared/lib/customHooks';
import type { StudyListProps } from './studyList.types';

/**
 * Holds the study info drawer state for the study list attached to a support request. Tracks drawer visibility together with the study id to fetch and exposes the toggle.
 *
 * @param _props - Component props, unused.
 * @returns Drawer state and its toggle handler.
 */
export const useStudyList = (_props: StudyListProps) => {
  const [state, setState] = useSetState({
    isVisibleStudyInfoDrawer: false,
    fetchStudyId: '',
  });

  /**
   * Opens or closes the study info drawer of the support request study list. Clears fetchStudyId and hides the drawer when it is already visible, otherwise stores row.study.id and shows it.
   *
   * @param row - Study record whose study id should be loaded.
   * @returns Nothing.
   */
  const toggleDisplayDrawer = (row?: any) => {
    if (state.isVisibleStudyInfoDrawer) {
      setState({
        isVisibleStudyInfoDrawer: false,
        fetchStudyId: '',
      });
    } else {
      setState({
        isVisibleStudyInfoDrawer: true,
        fetchStudyId: row?.study?.id,
      });
    }
  };

  return { state, toggleDisplayDrawer };
};
